const e={next:"Next",previous:"Previous"},o="slide";export{e as NAVIGATION_DIRECTION,o as SLIDE};
//# sourceMappingURL=CMSCartoonNavigationButton.constants.js.map
